import {
  Box,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { FC, useState } from 'react'

import Button from '@/components/button'
import InputText from '@/components/input-text'

import { HandleInviteMembersRequest } from '..'
import { useStyles } from './styles'

type UnsubmittedContentProps = {
  handleModal: () => void
  handleInviteMembers: HandleInviteMembersRequest
  sendingInvitations: boolean
}

const UnsubmittedContent: FC<UnsubmittedContentProps> = ({
  handleModal,
  handleInviteMembers,
  sendingInvitations,
}) => {
  const classes = useStyles()
  const [email, setEmail] = useState({ value: '', error: false })
  const [name, setName] = useState('')
  const [members, setMembers] = useState<{ email: string; name: string }[]>([])

  const addOnMembersList = () => {
    const isValidEmail =
      !email.error && !members.some((member) => member.email === email.value)

    if (isValidEmail) {
      setMembers([...members, { email: email.value, name }])
      setEmail({ value: '', error: false })
      setName('')
    } else {
      setEmail({ ...email, error: true })
    }
  }

  const removeMemberFromList = (email: string) => {
    setMembers(members.filter((member) => member.email !== email))
  }

  return (
    <>
      <DialogTitle classes={{ root: classes.title }} disableTypography>
        <Typography variant='h2'>Convidar membros</Typography>
        <Typography variant='subtitle1'>
          Preencha os campos abaixo e clique em adicionar para criar sua lista
          de convites.
        </Typography>
        <div>
          <InputText
            label='Email'
            type={'email'}
            InputLabelProps={{
              classes: {
                outlined: classes.inputLabel,
              },
            }}
            value={email.value}
            required
            onChange={({ target: { value } }) => setEmail({ ...email, value })}
            onBlur={(e) =>
              setEmail({ ...email, error: !e.target.checkValidity() })
            }
            error={email.error}
            helperText={email.error && 'Insira um e-mail válido!'}
          />
          <InputText
            label='Nome'
            InputLabelProps={{
              classes: {
                outlined: classes.inputLabel,
              },
            }}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <Button onClick={addOnMembersList} outlined disabled={!email.value}>
            Adicionar
          </Button>
        </div>
      </DialogTitle>
      <DialogContent classes={{ root: classes.content }}>
        {members.map(({ email, name }) => (
          <Box key={email}>
            <Typography variant='subtitle1'>{email}</Typography>
            <Typography>
              <b>{name || '-'}</b>
            </Typography>
            <IconButton
              onClick={() => removeMemberFromList(email)}
              size='small'
              color='inherit'
            >
              <Close />
            </IconButton>
          </Box>
        ))}
      </DialogContent>
      <DialogActions classes={{ root: classes.actions }}>
        <Button onClick={handleModal} labelOnly>
          Cancelar
        </Button>
        <Button
          onClick={() => handleInviteMembers(members)}
          disabled={!members.length}
          loading={sendingInvitations}
        >
          Enviar Convite
        </Button>
      </DialogActions>
    </>
  )
}

export default UnsubmittedContent
